<template>
  <div class="total-power">
    <custom-plane
      title="当前总功率"
      unit="(kWh)"
      :iconImg="require('@/assets/compImg/icon/all-power.png')"
    >
      <div class="total-content">
        <div class="chart-content">
          <custom-progress-circle
            showType="1"
            :text="setText(powerDataTotal)"
            :value="100"
            color="#2D82FF"
          ></custom-progress-circle>
        </div>
        <div class="num-content">
          <custom-charts :dataList="dataList"></custom-charts>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: {
        x: [],
        y: [],
      },
    };
  },
  props: {
    powerData: Object,
    pdjName: String,
  },
  mounted() {},
  watch: {
    powerData() {
      this.loadData();
    },
    pdjName() {
      this.loadData();
    },
  },
  computed: {
    powerDataTotal() {
      return this.powerData?.totalPower;
    },
    setNum() {
      if (this.pdjName == "PDJ_D") {
        return "06";
      } else {
        return "05";
      }
    },
  },
  methods: {
    setText(val) {
      if (!val) {
        return "-";
      } else {
        return val[this.setNum];
      }
    },
    loadData() {
      this.dataList = { x: [], y: [] };
      if (this.powerData?.totalPowerHistorical?.[this.setNum]) {
        // console.log(this.powerData?.totalPowerHistorical?.[this.setNum], "ss");
        this.powerData?.totalPowerHistorical?.[this.setNum].map((item) => {
          let [res] = Object.entries(item);
          this.dataList.x.push(res[0].slice(11, 13));
          this.dataList.y.push(res[1]);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.total-power {
  width: 100%;
  height: 232px;
  .total-content {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    .chart-content {
      width: 142px;
      height: 142px;
    }
    .num-content {
      margin-left: 27px;
      width: 203px;
      height: 139px;
    }
  }
}
</style>
